import React, { useCallback, useEffect, useState } from "react";
import {getData, postData, postFormData} from '../middleware/apiMiddleware';
import s from './SchoolItem.module.css';
import { useNavigate } from "react-router-dom";
import {RedButton, GreenButton, BlueButton} from './MyButton';
import {modifiedDate} from '../middleware/dateControl';
import ItemTypeIconModal from './Modal/ItemTypeIconModal';
import {keyItemList} from '../middleware/MyConstant';
import {Image} from 'react-bootstrap';

import MyComponentLoading from '../components/Utilities/MyComponentLoading';

export default function SchoolItem(prop) {	
	const navigate = useNavigate();
	
	let schoolId = prop.schoolId;
	const [target, setTarget] = useState(null);
	const [items, setItems] = useState([]);
	
	const [keyData, setKeyData] = useState(keyItemList);
	const fetchData = async (target) => {
		setItems([]);
		
		let res = await getData('item/listAllItems?target=' + target, navigate);
		
		let items = res.data;
		
		let res2 = await getData('schoolApi/listItems?schoolId=' + schoolId + '&target=' + target, navigate)
		let chosenIds = res2.data;

		for(let i of items) {
			if (chosenIds.includes(i.itemId)) {
				i.isChosen = true;
			} else {
				i.isChosen = false;
			}

			i.itemId = i.itemId.toString();
		}
		
		setItems(items);
	}
	
	const toggleItems = async (idx, itemId, isChosen) => {
		if (isChosen) {
			postData("schoolApi/removeItemFromSchool", {schoolId, itemId}, navigate); 
			
			items[idx].isChosen = false;
		} else {
			postData("schoolApi/addItemToSchool", {schoolId, itemId, target}, navigate); 
		
			items[idx].isChosen = true;
		}
		
		setItems([...items])
	}
	
	const chooseTarget = (target) => {
		setTarget(target);
		fetchData(target);
	}
	
	useEffect(() => {
		//fetchData();
	}, []);
	
	/*
	if (["371","394"].includes(schoolId)) {
		return (<div className={s.mainHolder} style={{textAlign:"left"}}>
			This school owns all published resources. No customization can be done.
		</div>)
	}*/
	
	const addAllToTarget = async () => {
		let itemIds = [];
		
		for(let i of items) {
			itemIds.push(i.itemId);
		}
		
		if (itemIds.length > 0) {
			await postData("schoolApi/addAllItemsToSchool", {schoolId, itemIds, target}, navigate); 
		}
		fetchData(target);
	}
	
	const removeAllToTarget = async () => {
		await postData("schoolApi/removeAllItemsToSchool", {schoolId, target}, navigate); 
		fetchData(target);
	}
	
	return (<div className={s.mainHolder}>
		{
			(["371","394"].includes(schoolId)) && (<div className={s.mainHolder} 
				style={{textAlign:"left", border:"1px solid red"}}>
				<p>This school owns all published resources. No customization can be done.</p>
				<p>New Cohort Logic requires customization.</p>
			</div>)
		}
		<div>
			<div style={{display:"flex", gap:"10px"}}>
				<RedButton isEnabled={target!= null}
					clickedAction={()=>{
						addAllToTarget();
					}} bText="Add all" />
				<RedButton isEnabled={target!= null}
					clickedAction={()=>{
						removeAllToTarget();
					}} bText="Remove all" />
			</div>
		
		
			<div style={{display:"flex", background:"#fceecf", margin:"10px 0"}}>
				<div style={{display:"flex", padding:"10px 0 0 0"}}>
					<div className={s.nonClickableTitle}>
						<span style={{cursor:"pointer"}}>Key-Item</span>
					</div>
					<div style={{fontWeight:"bold"}}>:</div>		
				</div>
				<div className={s.paramSectionHolder}>
					{
						keyData.map(
							(d, indexD) => (<>
								<div key={'ki-'+indexD} className={s.clickableOption}
									style={(target == d.searchKey) ? {background:"#ebccad"} : {}}
									onClick={() => {
										if (d.searchKey != target) {
											chooseTarget(d.searchKey)
										}
									}}>
									<ItemTypeIconModal itemType={d.itemType}/>
									<div>{d.title} </div>
								</div>
								{(indexD != keyData.length-1) &&(<span>•</span>)}
							</>)
						)
					}
				</div>
			</div>
		</div>
	
	
	
	
	
	
		<div className={s.gridContainer}>
			{items.map((item, index) => (
					<div key={index} className={s.gridItem} style={(item.isChosen) ? {backgroundColor:"#fab175", border: "3px solid #ff0a24"}:{backgroundColor:"lightblue"}}
						onClick={() => {
							toggleItems(index, item.itemId, item.isChosen);
						}}>
						<div style={{width: '100%', height: '80px', overflow: 'hidden', position: 'relative'}}>
							<img style={{height: '100%', 
                    width: '100%', 
                    position: 'absolute', 
                    top: '0',          // Align to the top
                    left: '50%', 
                    transform: 'translateX(-50%)', // Center horizontally
                    objectFit: 'cover'}} src={item.thumbnailPath} />	
						</div>
						<div style={{textAlign:"left", marginLeft:"10px"}}>
							<div>{item.itemId}</div>
							<div style={{fontSize:"0.7rem"}}>{item.name}</div>	
						</div>
					</div>
			))}
			{items.length % 10 !== 0 && (
					Array.from({ length: 10 - (items.length % 10) }).map((_, i) => (
							<div key={`empty-${i}`} className={s.gridIitemEmpty}></div>
					))
			)}
		</div>
	</div>);
	
}

